module.exports = __webpack_public_path__ + "static/media/video-test-bis-poster.1ee25e69.jpg";